import { WebAppConfig, WebAppConfigResponse } from '../client-domain.types';

/**
 * Every gated feature on, which is what most clients look like and what the builder
 * should therefore behave like by default. Switch one off per test rather than
 * starting from an empty document.
 */
export const webAppConfigFixture = (
  overrides?: Partial<WebAppConfig>,
): WebAppConfig => ({
  isLoyaltyCard: true,
  isEnterCode: true,
  catering: true,
  giftCard: { isActive: true },
  ...overrides,
});

/**
 * Shaped like the real response: the flags we read, buried in fields we don't.
 *
 * The surrounding fields are here so the narrowing has something to drop. The real
 * document also embeds the client configuration, credentials and all — represented
 * below by a harmless stand-in, because a fixture is checked in and the point is only
 * that the transform leaves nothing behind.
 */
export const webAppConfigResponseFixture = (
  overrides?: Partial<WebAppConfig>,
): WebAppConfigResponse => ({
  ...webAppConfigFixture(overrides),
  clientId: 'clt_palmlane',
  loyaltyOn: true,
  onOffWallet: true,
  inbox: true,
  loyaltyCardTitle: 'Your rewards',
  colors: { primary: '#123456' },
  clientConfig: { clientName: 'Palm Lane' },
});
